module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ef9ad7d985162ed527aca819ad691267.png";